"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  DateTimeFormatName: () => DateTimeFormatName,
  DateTimeFormatStyle: () => DateTimeFormatStyle,
  formatCurrency: () => formatCurrency,
  formatCurrencyForShopping: () => formatCurrencyForShopping,
  formatCurrencyWithOptions: () => formatCurrencyWithOptions,
  formatDateTime: () => formatDateTime
});
module.exports = __toCommonJS(src_exports);

// src/CurrencyFormatStyle.ts
var CurrencyFormatInfo = class {
  static {
    __name(this, "CurrencyFormatInfo");
  }
  constructor(roundingPlace, roundingMode) {
    this.roundingPlace = roundingPlace;
    this.roundingMode_ = roundingMode ?? "ceil";
  }
  /**
   * Returns fraction digits in number to use for the currency for the style.
   * 
   * This method mimics what ICU's getDefaultFractionDigits method does by using
   * the two objects CashDigitsOverrides and NonDefaultDigitsCurrecies
   */
  fractionDigits(currencyCode) {
    const override = CashDigitsOverrides[currencyCode];
    const nonDefault = NonDefaultDigitsCurrencies[currencyCode];
    return override ?? nonDefault ?? this.roundingPlace;
  }
  roundingMode() {
    return this.roundingMode_;
  }
};
var CurrencyFormatStyles = {
  [0 /* Shopping */]: new CurrencyFormatInfo(0),
  [1 /* ShoppingWithDecimals */]: new CurrencyFormatInfo(2),
  [2 /* Charge */]: new CurrencyFormatInfo(2)
};
var CashDigitsOverrides = {
  "AMD": 0,
  "COP": 0,
  "CRC": 0,
  "CZK": 0,
  "GYD": 0,
  "HUF": 0,
  "IDR": 0,
  "MNT": 0,
  "MUR": 0,
  "NOK": 0,
  "PKR": 0,
  "SEK": 0,
  "TWD": 0,
  "TZS": 0,
  "UZS": 0,
  "VEF": 0
};
var NonDefaultDigitsCurrencies = {
  "ADP": 0,
  "AFN": 0,
  "ALL": 0,
  "BHD": 3,
  "BIF": 0,
  "BYR": 0,
  "CLF": 4,
  "CLP": 0,
  "DJF": 0,
  "ESP": 0,
  "GNF": 0,
  "IQD": 0,
  "IRR": 0,
  "ISK": 0,
  "ITL": 0,
  "JOD": 3,
  "JPY": 0,
  "KMF": 0,
  "KPW": 0,
  "KRW": 0,
  "KWD": 3,
  "LAK": 0,
  "LBP": 0,
  "LUF": 0,
  "LYD": 3,
  "MGA": 0,
  "MGF": 0,
  "MMK": 0,
  "MRO": 0,
  "OMR": 3,
  "PYG": 0,
  "RSD": 0,
  "RWF": 0,
  "SLL": 0,
  "SOS": 0,
  "STD": 0,
  "SYP": 0,
  "TMM": 0,
  "TND": 3,
  "TRL": 0,
  "UGX": 0,
  "UYI": 0,
  "UYW": 4,
  "VND": 0,
  "VUV": 0,
  "XAF": 0,
  "XOF": 0,
  "XPF": 0,
  "YER": 0,
  "ZMK": 0,
  "ZWD": 0
};

// src/CurrencyFormat.ts
var CurrencyFormatCache = {};
function keyForCurrencyFormatCache(currencyCode, locale, style, symbol, options) {
  return [currencyCode, locale, style, symbol, serialize(options)].filter((v) => v !== void 0).join("::");
}
__name(keyForCurrencyFormatCache, "keyForCurrencyFormatCache");
var CurrencyFormat = class _CurrencyFormat {
  static {
    __name(this, "CurrencyFormat");
  }
  static instanceFor(currencyCode, locale, style, overrideSymbol, options) {
    const symbol = overrideSymbol ?? CurrencySymbolOverrides[currencyCode];
    const key = keyForCurrencyFormatCache(currencyCode, locale, style, symbol, options);
    let cf = CurrencyFormatCache[key];
    if (cf == null) {
      cf = new _CurrencyFormat({ currencyCode, locale, style, symbol, options });
      CurrencyFormatCache[key] = cf;
    }
    return cf;
  }
  constructor({ currencyCode, locale, style, symbol, options }) {
    this.currencyCode = currencyCode;
    this.locale = locale;
    this.symbol = symbol ?? CurrencySymbolOverrides[currencyCode];
    const info = CurrencyFormatStyles[style];
    this.fractionDigits = info.fractionDigits(currencyCode);
    const opts = options ?? {};
    this.formatter = new Intl.NumberFormat(this.locale, {
      style: "currency",
      currency: currencyCode,
      // Thai THB must always be formatted with a symbol according to the CurrencyFormat in Helpers
      currencyDisplay: currencyCode === "THB" ? "narrowSymbol" : "symbol",
      minimumFractionDigits: this.fractionDigits,
      maximumFractionDigits: this.fractionDigits,
      // @ts-ignore roundingMode is added in node v19, Chrome 106, Safari 16 and Firefox 116.
      roundingMode: info.roundingMode(),
      // Custom options may override any of the following settings
      ...opts
    });
  }
  // At this point we always use ceiling mode to format the number
  format(amount) {
    const overridden = this.symbol !== void 0 ? this.formatWithCurrencyOverride(amount, this.symbol) : this.formatter.format(amount);
    return overridden.replace(WhiteSpaceRegex, Nbsp);
  }
  formatWithCurrencyOverride(amount, overrideSymbol) {
    const parts = this.formatter.formatToParts(amount);
    const symbol = parts.find((p) => p.type === "currency")?.value;
    const formatted = this.formatter.format(amount);
    if (symbol == null) {
      return formatted;
    }
    return formatted.replace(symbol, overrideSymbol);
  }
};
var WhiteSpaceRegex = new RegExp(" |\u202F", "g");
var Nbsp = "\xA0";
var CurrencySymbolOverrides = {
  CAD: "CA$",
  AUD: "A$",
  COP: "COP",
  NZD: "NZ$",
  MXN: "MX$",
  ARS: "ARS",
  CLP: "CLP",
  UYU: "UYU",
  TWD: "NT$",
  SGD: "SGD"
};
function serialize(obj) {
  if (obj === void 0) {
    return void 0;
  }
  const sortedMap = Object.keys(obj).sort().map((key) => ({ [key]: obj[key] }));
  return JSON.stringify(sortedMap);
}
__name(serialize, "serialize");

// src/DateTimeFormat.ts
var DateTimeFormatCache = {};
function keyForDateTimeFormatCache(options, locale) {
  return `${locale}::${serialize2(options)}`;
}
__name(keyForDateTimeFormatCache, "keyForDateTimeFormatCache");
function serialize2(obj) {
  const sortedMap = Object.keys(obj).sort().map((key) => ({ [key]: obj[key] }));
  return JSON.stringify(sortedMap);
}
__name(serialize2, "serialize");
var DateTimeFormat = class _DateTimeFormat {
  static {
    __name(this, "DateTimeFormat");
  }
  static forStyle(style, locale) {
    return this.fromOptions(style.options, locale);
  }
  static fromOptions(options, locale) {
    const key = keyForDateTimeFormatCache(options, locale);
    let cached = DateTimeFormatCache[key];
    if (cached == null) {
      cached = new _DateTimeFormat(options, locale);
      DateTimeFormatCache[key] = cached;
    }
    return cached;
  }
  constructor(options, locale) {
    this.formatter = new Intl.DateTimeFormat(locale, options);
  }
  format(date) {
    return this.formatter.format(date);
  }
};

// src/DateTimeFormatStyle.ts
var DateTimeFormatStyle = class _DateTimeFormatStyle {
  static {
    __name(this, "DateTimeFormatStyle");
  }
  constructor(options) {
    this.options = options;
  }
  static {
    /**
     * en-US: 1/31/24
     * en-GB: 31/01/24
     * es-MX: 31/1/24
     */
    this.ShortDate = new _DateTimeFormatStyle({ year: "2-digit", month: "numeric", day: "numeric" });
  }
  static {
    /**
     * en-US: Jan 31, 2024
     * en-GB: 31 Jan 2024
     * es-MX: 31 ene 2024
     */
    this.MediumDate = new _DateTimeFormatStyle({ year: "numeric", month: "short", day: "numeric" });
  }
  static {
    /**
     * en-US: January 31, 2024
     * en-GB: 31 January 2024
     * es-MX: 31 de enero de 2024
     */
    this.LongDate = new _DateTimeFormatStyle({ year: "numeric", month: "long", day: "numeric" });
  }
  static {
    /**
     * en-US: Wednesday, January 31, 2024
     * en-GB: Wednesday, 31 January 2024
     * es-MX: miércoles, 31 de enero de 2024
     */
    this.FullDate = new _DateTimeFormatStyle({ year: "numeric", month: "long", day: "numeric", weekday: "long" });
  }
  static {
    /**
     * en-US: 1:23 AM
     * en-GB: 01:23
     * es-MX: 01:23
     */
    this.ShortTime = new _DateTimeFormatStyle({ hour: "numeric", minute: "numeric" });
  }
  static {
    /**
     * en-US: 1:23:04 AM
     * en-GB: 01:23:04
     * es-MX: 01:23:04
     */
    this.MediumTime = new _DateTimeFormatStyle({ hour: "numeric", minute: "numeric", second: "numeric" });
  }
  static {
    /**
     * en-US: 1:23:04 AM PST
     * en-GB: 1:23:04 GMT-8
     * es-MX: 1:23:04 GMT-8
     */
    this.LongTime = new _DateTimeFormatStyle({ hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short" });
  }
  static {
    /**
     * en-US: 1:23:04 AM Pacific Standard Time
     * en-GB: 1:23:04 Pacific Standard Time
     * es-MX: 1:23:04 hora estándar del Pacífico
     */
    this.FullTime = new _DateTimeFormatStyle({ hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "long" });
  }
  static {
    /**
     * en-US: Wed, Jan 31
     * en-GB: Wed, 31 Jan
     * es-MX: mié 31 de ene
     */
    this.ShortMonthDayShortWeekday = new _DateTimeFormatStyle({ month: "short", day: "numeric", weekday: "short" });
  }
  static {
    /**
     * en-US: Wed, Jan 31, 1:23 AM
     * en-GB: Wed, 31 Jan, 01:23
     * es-MX: mié 31 de ene, 01:23
     */
    this.ShortMonthDayShortWeekdayTime = new _DateTimeFormatStyle({ month: "short", day: "numeric", weekday: "short", hour: "numeric", minute: "numeric" });
  }
  static {
    /**
     * en-US: Jan 2024
     * en-GB: Jan 2024
     * es-MX: ene 2024
     */
    this.YearShortMonth = new _DateTimeFormatStyle({ year: "numeric", month: "short" });
  }
  static {
    /**
     * en-US: Wed, Jan 31, 2024
     * en-GB: 31 January
     * es-MX: mié, 31 de ene de 2024
     */
    this.YearShortMonthDayShortWeekday = new _DateTimeFormatStyle({ year: "numeric", month: "short", day: "numeric", weekday: "short" });
  }
  static {
    /**
     * en-US: January 31
     * en-GB: Wed, 31 Jan 2024
     * es-MX: 31 de enero
     */
    this.MonthDay = new _DateTimeFormatStyle({ month: "long", day: "numeric" });
  }
  /**
   * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options
   * @param options Intl.DateTimeFormatOptions
   * @returns new DateTimeFormatStyle instance
   */
  static Custom(options) {
    new Intl.DateTimeFormat("en-US", options);
    return new _DateTimeFormatStyle(options);
  }
  /**
   * DO NOT USE. This function is defined for automated tests
   */
  static fromName(name) {
    switch (name) {
      case 0 /* ShortDate */:
        return _DateTimeFormatStyle.ShortDate;
      case 1 /* MediumDate */:
        return _DateTimeFormatStyle.MediumDate;
      case 2 /* LongDate */:
        return _DateTimeFormatStyle.LongDate;
      case 3 /* FullDate */:
        return _DateTimeFormatStyle.FullDate;
      case 4 /* ShortTime */:
        return _DateTimeFormatStyle.ShortTime;
      case 5 /* MediumTime */:
        return _DateTimeFormatStyle.MediumTime;
      case 6 /* LongTime */:
        return _DateTimeFormatStyle.LongTime;
      case 7 /* FullTime */:
        return _DateTimeFormatStyle.FullTime;
      case 8 /* ShortMonthDayShortWeekday */:
        return _DateTimeFormatStyle.ShortMonthDayShortWeekday;
      case 9 /* ShortMonthDayShortWeekdayTime */:
        return _DateTimeFormatStyle.ShortMonthDayShortWeekdayTime;
      case 10 /* YearShortMonth */:
        return _DateTimeFormatStyle.YearShortMonth;
      case 11 /* YearShortMonthDayShortWeekday */:
        return _DateTimeFormatStyle.YearShortMonthDayShortWeekday;
      case 12 /* MonthDay */:
        return _DateTimeFormatStyle.MonthDay;
      default:
        throw new Error(`Invalid name ${name}`);
    }
  }
};
var DateTimeFormatName = /* @__PURE__ */ ((DateTimeFormatName2) => {
  DateTimeFormatName2[DateTimeFormatName2["ShortDate"] = 0] = "ShortDate";
  DateTimeFormatName2[DateTimeFormatName2["MediumDate"] = 1] = "MediumDate";
  DateTimeFormatName2[DateTimeFormatName2["LongDate"] = 2] = "LongDate";
  DateTimeFormatName2[DateTimeFormatName2["FullDate"] = 3] = "FullDate";
  DateTimeFormatName2[DateTimeFormatName2["ShortTime"] = 4] = "ShortTime";
  DateTimeFormatName2[DateTimeFormatName2["MediumTime"] = 5] = "MediumTime";
  DateTimeFormatName2[DateTimeFormatName2["LongTime"] = 6] = "LongTime";
  DateTimeFormatName2[DateTimeFormatName2["FullTime"] = 7] = "FullTime";
  DateTimeFormatName2[DateTimeFormatName2["ShortMonthDayShortWeekday"] = 8] = "ShortMonthDayShortWeekday";
  DateTimeFormatName2[DateTimeFormatName2["ShortMonthDayShortWeekdayTime"] = 9] = "ShortMonthDayShortWeekdayTime";
  DateTimeFormatName2[DateTimeFormatName2["YearShortMonth"] = 10] = "YearShortMonth";
  DateTimeFormatName2[DateTimeFormatName2["YearShortMonthDayShortWeekday"] = 11] = "YearShortMonthDayShortWeekday";
  DateTimeFormatName2[DateTimeFormatName2["MonthDay"] = 12] = "MonthDay";
  return DateTimeFormatName2;
})(DateTimeFormatName || {});

// src/index.ts
function formatCurrency(currencyCode, locale, amount, symbol) {
  return CurrencyFormat.instanceFor(currencyCode, locale, 1 /* ShoppingWithDecimals */, symbol).format(amount);
}
__name(formatCurrency, "formatCurrency");
function formatCurrencyForShopping(currencyCode, locale, amount, symbol) {
  return CurrencyFormat.instanceFor(currencyCode, locale, 0 /* Shopping */, symbol).format(amount);
}
__name(formatCurrencyForShopping, "formatCurrencyForShopping");
function formatCurrencyWithOptions(params) {
  const { currencyCode, locale, amount, symbol, options } = params;
  return CurrencyFormat.instanceFor(
    currencyCode,
    locale,
    1 /* ShoppingWithDecimals */,
    symbol,
    options
  ).format(amount);
}
__name(formatCurrencyWithOptions, "formatCurrencyWithOptions");
function formatDateTime(date, locale, style) {
  return DateTimeFormat.forStyle(style, locale).format(date);
}
__name(formatDateTime, "formatDateTime");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DateTimeFormatName,
  DateTimeFormatStyle,
  formatCurrency,
  formatCurrencyForShopping,
  formatCurrencyWithOptions,
  formatDateTime
});
